import React from 'react'
import { DateTime } from 'luxon'
import Box from '@material-ui/core/Box'
import Checkbox from '@material-ui/core/Checkbox'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'

const EmptyState = ({ type }) => {
  const styles = useStyles()

  return (
    <Box className={styles.noLeadsWrapper}>
      <Typography className={styles.emptyTitle}>No results found.</Typography>
      {type === 'leads' ? (
        <Typography className={styles.emptyCaption}>
          Try updating your coach profile to gain more interest from customers.
        </Typography>
      ) : null}
    </Box>
  )
}

export default ({ inquiries, contacts, addContact, type }) => {
  const styles = useStyles()

  if (!inquiries.length) {
    return <EmptyState type={type} />
  }

  return (
    <List disablePadding className={styles.contactList}>
      {inquiries.map(({ reviewUpdatedAt, contact }) => {
        const contactId = contact.id
        const isSelected = contacts.includes(contactId)
        const labelId = `review-contact-${contactId}`

        return (
          <ListItem
            button
            key={contactId}
            className={styles.contactRow}
            onClick={() => addContact(contactId)}
            aria-labelledby={labelId}
          >
            <Checkbox
              edge="start"
              color="primary"
              checked={isSelected}
              tabIndex={-1}
              disableRipple
              inputProps={{ 'aria-labelledby': labelId }}
            />
            <Box pl={2} className={styles.contactText}>
              <ListItemText
                id={labelId}
                primary={`${contact.firstName} ${contact.lastName}`}
                secondary={
                  reviewUpdatedAt
                    ? `Requested: ${DateTime.fromSQL(reviewUpdatedAt).toFormat(
                      'MMM d, yyyy',
                    )}`
                    : undefined
                }
              />
            </Box>
          </ListItem>
        )
      })}
    </List>
  )
}
